'use strict';

(function() {
	angular.module('dat.shared-components.session')
		.directive('datSessionLogin', datSessionLogin);

	datSessionLogin.$inject = ['$log', 'eventNameService'];

	var $log, eventNameService;

	function datSessionLogin(_$log_, _eventNameService_) {
		$log = _$log_; eventNameService = _eventNameService_;

		return {
			scope: {
				productName: '@',
				productImageClass: '@',
				forgotUsernameCallback: '&',
				forgotPasswordCallback: '&',
				loginCallbackPromise: '&'
			},
			templateUrl: '/app/shared-components/session/login.html',
			replace: true,
			link: linkFunction
		};
	}

	function linkFunction(scope) {
		activate();

		//////////////////////////////////////////

		function activate() {
			scope.forgotUsername = forgotUsername;
			scope.forgotPassword = forgotPassword;
			scope.login = login;
			scope.isLoggingIn = false;
			scope.loginErrorMessage = '';
		}

		function forgotUsername() {
			scope.forgotUsernameCallback();
		}

		function forgotPassword() {
			scope.forgotPasswordCallback();
		}

		function login() {
			scope.isLoggingIn = true;
			scope.loginCallbackPromise()
				.then(function (){
					// Resolved
					scope.loginErrorMessage = '';
					scope.$emit(eventNameService.sessionLogin.loginSuccessful);

				}, function (response) {
					// Rejected
					scope.$emit(eventNameService.sessionLogin.loginFailed);
					scope.loginErrorMessage = response.message;
					$log.debug('Login failed');
					if (angular.mock) $log.debug('Login failed response: ' + angular.mock.dump(response));
				})
				.finally(function (){
					scope.isLoggingIn = false;
				});
		}
	}
})();
